// extracted by mini-css-extract-plugin
module.exports = {"button":"ArrowBtn_button__myjs3","icon":"ArrowBtn_icon__3D_6x","text":"ArrowBtn_text__3vJju"};